import React, { FunctionComponent } from "react"
import { useToastAlert, Button, Icon } from "@kuali/pure-ui"
import "./styles.scss"

interface Props {
  onDeleteActionItem: any
  onUndoAction: any
}

const DeleteToast: FunctionComponent<Props> = ({
  onDeleteActionItem,
  onUndoAction
}) => {
  const [alert, showAlert] = useToastAlert("#mainContent")

  const showToastSuccess = (text = "Item was deleted") => {
    // Show the alert. First parameter is the message,
    // second object can contain any props on the `ToastAlert` component
    return showAlert(text, {
      id: "tertiary-alert",
      color: "green",
      primaryButtonLabel: "Undo",
      onPrimaryButtonClicked: onUndoAction
    })
  }

  const handleButtonClick = (event) => {
    event.preventDefault()

    // we pass callback for toast display back as a prop
    onDeleteActionItem(showToastSuccess)
  }

  return (
    <React.Fragment>
      <Button
        className="delete-button"
        onClick={handleButtonClick}
        kind="transparent"
        color="black"
        style={{
          color: "#555555",
          width: "100%",
          height: "20px",
          margin: "0px",
          padding: "0px"
        }}
        icon={<Icon name="delete" />}
      >
        <span className="visually-hidden">Delete</span>
      </Button>
      {alert}
    </React.Fragment>
  )
}

export default DeleteToast
